/**
 * @desc 待结算信息提交
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(body: defs.tms.TransportDjsRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/djsTransportMaster`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
